// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import useDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import BuyItAgainReducer from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgain.reducer';
import BuyItAgainSaga from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgain.saga';
import {
  buyItAgainProducts,
  getBiaInitialApiActualProductCount,
} from '../../../../BuyItAgain/container/BuyItAgain.selectors';
import {
  getBuyItAgainBagPageProducts,
  setBIAAvailableProduct,
} from '../../../../../CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.actions';
import BuyItAgainBagPageReducer from '../../../../../CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.reducer';
import BuyItAgainBagPageSaga from '../../../../../CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.saga';
import BIAOrderHistory from '../views';
import { getBIABagpageConfigData } from '../../../../../../../reduxStore/selectors/session.selectors';
import { getUserLoggedInState } from '../../../../User/container/User.selectors';
import { openQuickViewWithValues } from '../../../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { getIsQVOpen } from '../../../../../../common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import { getBIAAvailProduct } from '../../../../../CnC/BuyItAgainBagPage/container/BuyItAgainBagPage.selectors';

const mapStateToProps = (state) => {
  return {
    biaProducts: buyItAgainProducts(state),
    getBIAConfigData: getBIABagpageConfigData(state),
    isLoggedIn: getUserLoggedInState(state),
    isQVModalOpen: getIsQVOpen(state),
    biaInitialApiActualProductCount: getBiaInitialApiActualProductCount(state),
    biaAvailProduct: getBIAAvailProduct(state),
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    getBIABagPageProducts: () => dispatch(getBuyItAgainBagPageProducts()),
    onQuickViewOpenClick: (payload) => dispatch(openQuickViewWithValues(payload)),
    setBIAAvailableProductActn: (payload) => dispatch(setBIAAvailableProduct(payload)),
  };
};
const withReducer = withDynamicReducer([
  {
    key: 'buyItAgain',
    reducer: BuyItAgainReducer,
  },
  {
    key: 'buyItAgainBagPage',
    reducer: BuyItAgainBagPageReducer,
  },
]);
const withSaga = useDynamicSaga([
  { key: 'BuyItAgainSaga', saga: BuyItAgainSaga },
  {
    key: 'BuyItAgainBagPageSaga',
    saga: BuyItAgainBagPageSaga,
  },
]);
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withReducer, withSaga, withConnect)(BIAOrderHistory);
